export default {"src":"/_next/static/media/creator-icon.bff86131.svg","height":20,"width":20};